import React, { Fragment } from 'react';
import { useTranslate } from 'Translate';

export default (props) => {
  const { columns, data } = props;
  const i18n = useTranslate();
    const { t } = i18n;

  return (
    <div className="inventory-table-container">
      <div className="inventory-table">
        <table>
          <thead>
            <tr>
              {columns?.sw_details_listing?.list?.map(item =>
                <th className={`${item?.longCol ? 'long-col' : ''} text-${item.align}`} key={`Title ${item.title}`}>
                  {item.title}
                </th>
              )}
            </tr>
          </thead>
          <tbody>
            {data?.list?.map((listItem, listItemIndex) => 
              <tr key={`Child List Item ${listItemIndex}`}>
                <td>{listItem.reference}</td>
                <td>{listItem.date}</td>
                <td>{listItem.location_code}</td>
                <td>{listItem.item}</td>
                <td>{listItem.uom}</td>
                <td>{listItem.status}</td>
                <td align='right'>{listItem.qty}</td>
                <td align='right'>{parseFloat(listItem.unit_cost).toFixed(8)}</td>
                <td align='right'>{parseFloat(listItem.inv_cost).toFixed(8)}</td>
              </tr>
            )}

            
            <tr className='bg-gray text-white'>
              <td colSpan={5}></td>
              <td>{t("SalesReporting.grand_total")}</td>
              {data?.grand_total?.map((item, index) => 
                <td key={`Grand Total ${item} ${index}`} align='right'>{parseFloat(item).toFixed(8)}</td>
              )}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
}